import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent } from 'lib-trend-core';
import { CAMPAIGN_REFRESH_OPTIONS, CampaignRefreshOption, CampaignRefreshPreferenceService } from '../campaign-refresh-preference.service';

/**
 * Refresh-cadence selector of the campaign screens (DEV-2034).
 *
 * Hyper choice-dropdown pattern: a primary button carrying the current option,
 * `mat-menu` with the rest. The preference is a single one — choosing here
 * changes the cadence of the list AND the panel at the same time.
 */
@Component({
    selector: 'campaign-refresh-interval',
    templateUrl: './campaign-refresh-interval.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignRefreshIntervalComponent extends AbstractComponent {

  readonly options: Array<CampaignRefreshOption> = CAMPAIGN_REFRESH_OPTIONS;

  constructor(
    injector: Injector,
    private readonly preference: CampaignRefreshPreferenceService,
  ) {
    super(injector);
  }

  get currentOption(): CampaignRefreshOption {
    return this.options.find((option) => option.ms === this.preference.intervalMs)
      ?? this.options[this.options.length - 1];
  }

  choose(ms: number): void {
    this.preference.setIntervalMs(ms);
  }

}
